// FullPageSpinner.js
import React, { useEffect, useState } from 'react';
import { ThreeDot } from 'react-loading-indicators';
import './LoadingScreen.css';

const FullPageSpinner = ({ delay = 300 }) => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const timer = setTimeout(() => setVisible(true), delay);
        return () => clearTimeout(timer);
    }, [delay]);

    if (!visible) return null;

    return (
        <div className="fullpage-spinner-overlay">
            <ThreeDot variant="bounce" color="#FF4367" size="medium" text="Nalaganje" textColor="#FF4367" />
        </div>
    );
};

export default FullPageSpinner;